import { EnvConfig } from './types'

export const prodConfig: EnvConfig = {
  isDev: false,
  isProd: true,
  isTest: false,
}
